class CollapsePermissions {
  constructor() {
    this.jQuery = window.$
    this.bindEvents()
  }

  bindEvents() {
    this.addEventCollapseHide(this)
    this.updateCollectionCheckBoxes(this)
  }

  addEventCollapseHide(self) {
    self.jQuery('.collapse-permissions').click(function eventCollapseHide(event) {
      const collapse = self.hideCollapse(self, this)

      if (collapse.hasClass('show')) {
        event.preventDefault()
        event.stopPropagation()
        collapse.collapse('hide')
      }

      self.removeFormPermissions()
    })
  }

  hideCollapse(self, collapsePermissions) {
    const userId = collapsePermissions.getAttribute('data-user-id')
    const userUuid = collapsePermissions.getAttribute('data-user-uuid')
    const userModuleEntityId = collapsePermissions.getAttribute('data-user-module-entity-id')
    let collapse = null

    if (userId) {
      collapse = self.jQuery(`#collapse-account-user-permissions-${userId}`)
      self.jQuery('[id^="collapse-entities-for-user-"].show').collapse('hide')
      self.jQuery('[class*="entities-for-user-btn-"] i.la-angle-up').removeClass('la-angle-up')
        .addClass('la-angle-down')
    } else if (userUuid) {
      collapse = self.jQuery(`#collapse-entities-for-user-${userUuid}`)
      self.jQuery('[id^="collapse-account-user-permissions-"].show').collapse('hide')
      self.jQuery('[class*="entities-for-user-btn-"] i.la-angle-up').removeClass('la-angle-up')
        .addClass('la-angle-down')
    } else {
      collapse = self.jQuery(`#collapse-user-module-entity-permissions-${userModuleEntityId}`)
    }

    return collapse
  }

  updateCollectionCheckBoxes(self) {
    self.jQuery('#authorization_resource_access_form_admin_access').change(function changeCheckBoxe() {
      const checkAdmValue = this.type === 'hidden' ? (this.value === 'true') : this.checked

      self.jQuery('.resource_actions_permissions').each(function changeCheckBox() {
        if (checkAdmValue) {
          this.checked = true
          this.disabled = true
        } else {
          this.disabled = false
        }
      })
    })
  }

  removeFormPermissions() {
    this.jQuery('[id^="collapse-account-user-permissions-"] .card-body').html('')
    this.jQuery('[id^="collapse-user-module-entity-permissions-"] .card-body').html('')
  }
}

export default CollapsePermissions
